export default function InputNumber() {
  return {}
}
